import React, { PureComponent } from 'react';
import { Table, Button, Input, Modal, message, InputNumber, Popconfirm } from 'antd';
import API from '../../../api/api';
import UEditor from "../../components/ueditor/ueditor";
import './openInfo.less';
var uploader = require('../../../thirdTool/alioss/upload.js');
class OpenInfo extends PureComponent {
    constructor(props) {
        super(props)
        this.showCircleList = this.showCircleList.bind(this);
        this.onPaginationChange = this.onPaginationChange.bind(this);
        this.showManagePane = this.showManagePane.bind(this);
        this.onShowSizeChange = this.onShowSizeChange.bind(this);
    }
    state = {
        testStr: 'i am a string for test',
        columns: [],
        data: [],
        loading: false,
        showManagePane: false,//控制是否进入到管理页面
        //addModal下的变量
        errorCircleIdShow: false,//控制addModal内错误信息显示 当添加功能公众圈id为空时
        errorAddAppNameShow: false,//当添加功能app名称为空时
        addModalCircleId: '',//添加功能公众圈id
        addModalAppName: '',//添加功能公众圈应用名称
        addOpenInfoName: '',//添加公开信息 名称
        addOpenInfoLogo: '',//添加公开信息 logo
        addOpenInfoIndex: '',//添加公开信息 展示位置
        addOpenInfoContent: '',//添加公开信息 内容
        errorAddInfoNameShow: false,//添加公开信息 名称为空
        errorAddInfoLogoShow: false,//添加公开信息 logo为空
        errorAddInfoIndexShow: false,//添加公开信息 位置为空
        errorAddInfoContentShow: false,//添加公开信息 内容为空
        //editModal下的变量
        editModalCircleId: '',
        editModalAppName: '',
        editModalCircleName: '',
        errorEditAppNameShow: false,
        modalType: '',//控制弹出的modal的类型
        searchCircleId: '',//搜索字段
        searchCirCleName: '',
        manageCircleId: '',
        operateDisplayId: '',
        modalWidth: 500,
        pagination: {
            hideOnSinglePage: true,
            showQuickJumper: true,
            showSizeChanger: false,
            addModalVisible: false,//添加或编辑对话框
            onShowSizeChange: this.onShowSizeChange,
            addModalTitle: '',
            pageSize: 5,
            current: 1,
            total: 0,
            showTotal: total => `总${total}条`,
            onChange: this.onPaginationChange
        },
    }
    initPage(){
        if (this.getQueryString('type') == 0) {
            this.setState({
                manageCircleId: this.getQueryString('circleId')
            })
            this.setState({ showManagePane: true, modalWidth: 900 })
            this.showFuncList();
        }
        else {
            this.setState({ showManagePane: false, modalWidth: 500 })
            this.showCircleList();
        }
    }
    componentDidMount(){
        console.log('componentDidMount')
        this.initPage();
    }
    componentWillReceiveProps(nextProps) {
        console.log('componentWillReceiveProps')
        this.initPage();
    }
    getQueryString(name) {//解析url
        const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        const urlObj = window.location;
        var r = urlObj.href.indexOf('#') > -1 ? urlObj.hash.split("?")[1].match(reg) : urlObj.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    }
    showManagePane(data) {
        this.setState({
            manageCircleId: data.circleId
        }, () => {
            this.props.history.push('/openInfo?type=0&&circleId=' + data.circleId)
        })
    }
    onPaginationChange(pageCounter) {
    }
    onShowSizeChange(current, pageSize) {
    }
    onSearchCircleIdChange = e => {
        this.setState({ searchCircleId: e.target.value.trim() })
    }
    onSearchCirCleNameChange = e => {
        this.setState({ searchCircleName: e.target.value.trim() })
    }
    searchCircle = e => {//根据公众圈名称或者ID进行搜索
        const { searchCircleId, searchCircleName } = this.state;
        const pagination = { ...this.state.pagination };
        pagination.current = 1;
        pagination.pageSize = 5;
        this.setState({
            pagination
        }, () => {
            let param = {
                pageNum: 5,
                pageIndex: 1
            }
            if (searchCircleId)
                param.circleId = searchCircleId
            if (searchCircleName)
                param.circleName = searchCircleName
            this.getCircleList(param);
        })
    }
    async getCircleList(params) { //获取公众圈列表
        //this.setState({ loading: true });
        let result = await API.getCircleList(params);
        if (!result) {
            this.setState({ loading: false });
            return;
        }
        if (result.status === "1") {
            const pagination = { ...this.state.pagination };
            pagination.total = Number(result.data.circleCount);
            this.setState({
                loading: false,
                data: result.data.circleList,
                pagination
            });
        }
        if (result.status === "14014") {
            message.error(result.msg);
            //this.props.history.replace('/welcomePage')
        }
    };

    async getFuncList(params) { //获取公开信息列表
        // this.setState({ loading: true });
        let result = await API.getFuncList(params);
        if (!result) return;
        if (result.status === "1") {
            const pagination = { ...this.state.pagination };
            pagination.total = 0;
            pagination.current = 1;
            pagination.pageSize = 10000;
            this.setState({
                loading: false,
                data: result.data.displayList,
                pagination
            });
        }
        if (result.status === "14014") {
            message.error(result.msg)
        }
    };

    async getOpenInfoDetail(params, value) { //获取公开信息详情

        let result = await API.getOpenInfoDetail(params);
        if (!result) return;
        if (result.status === "1") {
            if (result.data.displayVO) {
                let data = result.data.displayVO;
                this.setState({
                    addOpenInfoName: data.displayTitle,//添加公开信息 名称
                    addOpenInfoLogo: data.displayImage,//添加公开信息 logo
                    addOpenInfoIndex: data.sortValue,//添加公开信息 展示位置
                    addOpenInfoContent: data.displayDesc,//添加公开信息 内容
                }, () => {
                    const { addOpenInfoLogo } = this.state;
                    this.setState({
                        modalType: value.modalType,
                        addModalTitle: value.addModalTitle,
                        addModalVisible: true,
                    }, () => {
                        setTimeout(() => {
                            document.getElementById('chooseLogo').style.backgroundImage = 'url(' + addOpenInfoLogo + ')';
                        })
                    })
                })
            }
        }
        if (result.status === "14014") {
            message.error(result.msg)
        }
    };
    async deleteFunction(params) { //删除公众圈功能
        let result = await API.deleteFunction(params);
        if (!result) return;
        if (result.status === "1") {
            message.success('删除成功');
            let param = {
                pageNum: 5,
                pageIndex: 1
            }
            this.getCircleList(param);
        }
        if (result.status === "14014") {
            message.error(result.msg);
        }
    };
    async deleteDisplay(params) { //删除展示信息
        let result = await API.deleteDisplay(params);
        const { manageCircleId } = this.state;
        if (!result) return;
        if (result.status === "1") {
            message.success('删除成功');
            let param = {
                circleId: manageCircleId
            }
            this.getFuncList(param);
        }
        else if (result.status === "14014") {
            message.error(result.msg);
        }
        else {
            message.error(result.msg);
        }
    };
    async addFunc(params) { // 增加公众圈功能
        let result = await API.addFunction(params);
        if (!result) return;
        if (result.status === "1") {
            message.success('成功');
            let param = {
                pageNum: 5,
                pageIndex: 1
            }
            this.getCircleList(param);
        }
        else if (result.status === "14014") {
            message.error(result.msg);
        }
        else {
            message.error(result.msg);
        }
    };
    async addOpenInfo(params) {//增加公开信息
        const { manageCircleId } = this.state;
        let result = await API.addOpenInfo(params);
        if (!result) return;
        if (result.status === "1") {
            message.success('成功');
            let param = {
                circleId: manageCircleId
            }
            this.getFuncList(param);
        }
        else if (result.status === "14014") {
            message.error(result.msg);
        }
        else {
            message.error(result.msg);
        }
    }
    showCircleList() {
        let columns = [
            {
                title: '公众圈ID',
                dataIndex: 'circleId',
                key: 'circleId',
            },
            {
                title: '公众圈名称',
                dataIndex: 'circleName',
                key: 'circleName',
            },
            {
                title: '公开内容管理',
                key: 'openInfoManage',
                render: (data) => (
                    <Button key={'manageBtn' + data.circleId} type="primary" onClick={this.showManagePane.bind(this, data)}>管理</Button>
                ),
            },
            {
                title: '操作',
                key: 'actionFunc',
                render: (data) => (
                    <div className="operateBtnBlock">
                        <Button key={'editBtn' + data.circleId} type="primary" className="editBtn" onClick={this.showModal.bind(this, 'edit', data)}>编辑</Button>
                        <Popconfirm title="确定删除该公众圈吗？"
                            onConfirm={this.deleteFuncOrDis.bind(this, 'func', data)}
                            okText="确定"
                            cancelText="取消"
                        >
                            <Button key={'deleteBtn' + data.circleId} type="danger" className="deleteBtn">删除</Button>
                        </Popconfirm>
                    </div>
                ),
            }]
        this.setState({ columns });
        const pagination = { ...this.state.pagination };
        pagination.current = 1;
        pagination.pageSize = 5;
        this.setState({
            pagination
        });
        let param = {
            pageNum: 5,
            pageIndex: 1
        }
        this.getCircleList(param);
    }
    showFuncList() {
        let columns = [
            {
                title: '公开信息名称',
                dataIndex: 'displayTitle',
                key: 'displayTitle',
            },
            {
                title: '公开信息logo',
                key: 'displayImage',
                render: (data) => (
                    <div className="openInfoLogo" key={'openInfoLogo' + data.displayId}
                        style={{
                            backgroundImage: 'url(' + data.displayImage + ')'
                        }}
                    ></div>
                ),
            },
            {
                title: '公开信息位置',
                key: 'sortValue',
                dataIndex: 'sortValue',
            },
            {
                title: '操作',
                key: 'actionOpenInfo',
                render: (data) => (
                    <div className="operateBtnBlock">
                        <Button key={'editBtn' + data.displayId} type="primary" className="editBtn" onClick={this.showModal.bind(this, 'edit', data)}>编辑</Button>
                        <Popconfirm title="确定删除公开信息吗？"
                            onConfirm={this.deleteFuncOrDis.bind(this, 'display', data)}
                            okText="确定"
                            cancelText="取消"
                        >
                            <Button key={'deleteBtn' + data.displayId} type="danger" className="deleteBtn">删除</Button>
                        </Popconfirm>
                    </div>
                ),
            }]
        this.setState({ columns });
        const { manageCircleId } = this.state;
        let param = {
            circleId: this.getQueryString('circleId')
        }
        this.getFuncList(param);
    }
    deleteFuncOrDis(type, idInfo) {
        type == 'func' ? this.deleteFunction({ circleId: idInfo.circleId }) : this.deleteDisplay({ displayId: idInfo.displayId })
    }
    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.setState({ pagination });
        const { showManagePane, searchCircleId, searchCircleName } = this.state;
        if (!showManagePane) {
            let param = {
                pageNum: pager.pageSize,
                pageIndex: pager.current
            }
            if (searchCircleId)
                param.circleId = searchCircleId
            if (searchCircleName)
                param.circleName = searchCircleName
            this.getCircleList(param);
        }
        else {

        }
        // this.getList({
        //     msgType: this.state.key,
        //     curPageNo: pagination.current,
        //     pageCount: pagination.pageSize,
        //     startTime,
        //     endTime,
        // });
    };
    circleIdChange = e => {//公众圈ID项
        this.setState({
            addModalCircleId: e.target.value.trim()
        })
        if (e.target.value.trim()) {
            this.setState({ errorCircleIdShow: false })
            return;
        }
    }
    appNameChange = (type, e) => {//应用名称项
        if (type == 'add') {
            this.setState({
                addModalAppName: e.target.value.trim()
            })
            if (e.target.value.trim()) {
                this.setState({ errorAddAppNameShow: false })
                return;
            }
        }
        else if (type == 'edit') {
            console.log(e.target.value.trim())
            this.setState({
                editModalAppName: e.target.value.trim()
            })
            if (e.target.value.trim()) {
                this.setState({ errorEditAppNameShow: false })
                return;
            }
        }
    }
    openInfoChange = (type, e) => {//公开信息名称项
        if (type == 'name') {
            this.setState({
                addOpenInfoName: e.target.value.trim()
            })
            if (e.target.value.trim()) {
                this.setState({ errorAddInfoNameShow: false })
                return;
            }
        }
        else if (type == 'index') {
            this.setState({
                addOpenInfoIndex: e
            })
            if (e) {
                this.setState({ errorAddInfoIndexShow: false })
                return;
            }
        }
    }
    showModal = (type, circleInfo, e) => {//弹出添加公众圈信息对话框
        let typeAndTitleMap = new Map();
        typeAndTitleMap.set('addfalse', { modalType: 'addCircle', addModalTitle: '添加公众圈' })
        typeAndTitleMap.set('addtrue', { modalType: 'addOpenInfo', addModalTitle: '添加公开信息' })
        typeAndTitleMap.set('editfalse', { modalType: 'editCircle', addModalTitle: '编辑' })
        typeAndTitleMap.set('edittrue', { modalType: 'editOpenInfo', addModalTitle: '编辑公开信息' })
        const { showManagePane } = this.state;
        let keyStr = type + showManagePane
        let value = typeAndTitleMap.get(keyStr)
        if (circleInfo && type == 'edit' && !showManagePane) {//编辑公众圈应用名称
            this.setState({
                modalType: value.modalType,
                addModalTitle: value.addModalTitle,
                addModalVisible: true,
                editModalCircleId: circleInfo.circleId,
                editModalAppName: circleInfo.functionName,
                editModalCircleName: circleInfo.circleName
            })
        }
        if (circleInfo && type == 'edit' && showManagePane) {
            const { manageCircleId } = this.state
            this.setState({ operateDisplayId: circleInfo.displayId })
            let param = {
                displayId: circleInfo.displayId,
                circleId: manageCircleId
            }
            this.getOpenInfoDetail(param, value)
        }
        if (type == 'add') {
            this.setState({
                modalType: value.modalType,
                addModalTitle: value.addModalTitle,
                addModalVisible: true,
            })
        }
        let self = this;
        if (showManagePane) {//弹出添加或者编辑公开信息页面时 为其初始化上传图片组件
            setTimeout(() => {
                if (document.getElementById('chooseLogo')) {
                    uploader({
                        serverUrl: 'http://app.im-dangdang.com/promotion/oss/policy',
                        upload_button: 'chooseLogo',
                        multi: false,
                        extensions: 'jpg,png,bmp,jpeg',
                        max: '2MB',
                        added: function () {
                        },
                        success: function (file_url, file) {
                            self.setState({
                                addOpenInfoLogo: file_url,
                                errorAddInfoLogoShow: false
                            })
                            document.getElementById('chooseLogo').style.backgroundImage = 'url(' + file_url + ')';
                        },
                        error: function (msg) {
                            message.error(msg)
                        }
                    })
                }
            }, 100)
        }
    };
    handleUEditorChange = (content) => { //编辑器内容变化
        this.setState({
            addOpenInfoContent: content.trim()
        })
        if (content) {
            this.setState({ errorAddInfoContentShow: false });
        }
    }
    handleAddModalOk = e => {//添加或编辑对话框点击确定后
        const { modalType } = this.state;
        if (modalType == 'addCircle') {//添加公众圈的确认按钮点击事件
            const { addModalCircleId, addModalAppName } = this.state;
            if (!addModalCircleId) {
                this.setState({ errorCircleIdShow: true })
            }
            if (!addModalAppName) {
                this.setState({ errorAddAppNameShow: true })
            }
            if (!addModalCircleId || !addModalAppName)
                return;
            this.addFunc({ circleId: addModalCircleId, funcAlias: addModalAppName })
        }
        else if (modalType == 'editCircle') {//编辑公众圈的确认按钮点击事件
            const { editModalAppName, editModalCircleId } = this.state;
            if (!editModalAppName) {
                this.setState({ errorEditAppNameShow: true })
                return;
            }
            this.addFunc({ circleId: editModalCircleId, funcAlias: editModalAppName })
        }
        else if (modalType == 'addOpenInfo' || modalType == 'editOpenInfo') {
            const { addOpenInfoLogo, addOpenInfoName, addOpenInfoContent, addOpenInfoIndex, manageCircleId, operateDisplayId } = this.state;
            !addOpenInfoLogo && this.setState({ errorAddInfoLogoShow: true })
            !addOpenInfoName && this.setState({ errorAddInfoNameShow: true })
            !addOpenInfoContent && this.setState({ errorAddInfoContentShow: true })
            !addOpenInfoIndex && this.setState({ errorAddInfoIndexShow: true })
            if (!addOpenInfoLogo || !addOpenInfoName || !addOpenInfoContent || !addOpenInfoIndex) {
                setTimeout(() => {
                    let antModal = document.getElementsByClassName('ant-modal-wrap')[0];
                    let noValueErrorDiv = document.getElementsByClassName('noValueError')[0];
                    console.log(antModal, noValueErrorDiv)
                    if (antModal && noValueErrorDiv) {

                        antModal.scrollTop = noValueErrorDiv.offsetTop;
                    }
                })
                return;
            }
            let param = {
                circleId: manageCircleId,
                displayTitle: addOpenInfoName,
                displayDesc: addOpenInfoContent,
                displayImage: addOpenInfoLogo,
                sortValue: addOpenInfoIndex,
            }
            if (modalType == 'editOpenInfo')
                param.displayId = operateDisplayId
            this.addOpenInfo(param);
        }
        this.setState({
            addModalVisible: false,
            errorCircleIdShow: false,//控制addModal内错误信息显示 当添加功能公众圈id为空时
            errorAddAppNameShow: false,//当添加功能app名称为空时
            addModalCircleId: '',//添加功能公众圈id
            addModalAppName: '',//添加功能公众圈应用名称
            addOpenInfoName: '',//添加公开信息 名称
            addOpenInfoLogo: '',//添加公开信息 logo
            addOpenInfoIndex: '',//添加公开信息 展示位置
            addOpenInfoContent: '',//添加公开信息 内容
            errorAddInfoNameShow: false,//添加公开信息 名称为空
            errorAddInfoLogoShow: false,//添加公开信息 logo为空
            errorAddInfoIndexShow: false,//添加公开信息 位置为空
            errorAddInfoContentShow: false,//添加公开信息 内容为空
            //editModal下的变量
            editModalCircleId: '',
            editModalAppName: '',
            editModalCircleName: '',
            errorEditAppNameShow: false,
            editOpenInfoName: '',//编辑公开信息 名称
            editOpenInfoLogo: '',//编辑公开信息 logo
            editOpenInfoIndex: '',//编辑公开信息 展示位置
            editOpenInfoContent: '',//编辑公开信息 内容
            operateDisplayId: ''
        });
    };

    handleAddModalCancel = e => {//添加或编辑对话框点击取消后
        this.setState({
            addModalVisible: false,
            errorCircleIdShow: false,//控制addModal内错误信息显示 当添加功能公众圈id为空时
            errorAddAppNameShow: false,//当添加功能app名称为空时
            addModalCircleId: '',//添加功能公众圈id
            addModalAppName: '',//添加功能公众圈应用名称
            addOpenInfoName: '',//添加公开信息 名称
            addOpenInfoLogo: '',//添加公开信息 logo
            addOpenInfoIndex: '',//添加公开信息 展示位置
            addOpenInfoContent: ' ',//添加公开信息 内容
            errorAddInfoNameShow: false,//添加公开信息 名称为空
            errorAddInfoLogoShow: false,//添加公开信息 logo为空
            errorAddInfoIndexShow: false,//添加公开信息 位置为空
            errorAddInfoContentShow: false,//添加公开信息 内容为空
            //editModal下的变量
            editModalCircleId: '',
            editModalAppName: '',
            editModalCircleName: '',
            errorEditAppNameShow: false,
            editOpenInfoName: '',//编辑公开信息 名称
            editOpenInfoLogo: '',//编辑公开信息 logo
            editOpenInfoIndex: '',//编辑公开信息 展示位置
            editOpenInfoContent: '',//编辑公开信息 内容
            operateDisplayId: ''
        });
    };
    showUpload = e => {

    }
    render() {
        const { columns,
            data,
            pagination,
            loading,
            showManagePane,
            addModalVisible,
            addModalTitle,
            errorAddAppNameShow,
            errorCircleIdShow,
            modalType,//控制弹窗类型
            editModalCircleId,
            editModalAppName,
            errorEditAppNameShow,
            editModalCircleName,
            errorAddInfoNameShow,
            errorAddInfoLogoShow,
            errorAddInfoIndexShow,
            errorAddInfoContentShow,
            modalWidth,
            addOpenInfoContent,
            addOpenInfoIndex,
            addOpenInfoLogo,
            addOpenInfoName
        } = this.state;
        return (
            <div className="OpenInfoPane">
                <div className="addAndSearch">
                    {
                        showManagePane && <Button className="add" type="default" onClick={() => {
                            this.props.history.push('/openInfo')
                        }}>返回</Button>
                    }
                    <Button className="add" type="primary" onClick={this.showModal.bind(this, 'add')}>添加</Button>
                    {
                        !showManagePane &&
                        <div className="searchBlock">
                            <Input className="circleId" placeholder="公众圈ID" onChange={this.onSearchCircleIdChange} />
                            <Input className="appName" placeholder="公众圈名称" onChange={this.onSearchCirCleNameChange} />
                            <Button onClick={this.searchCircle.bind(this)}>搜索</Button>
                        </div>
                    }
                </div>
                <Table columns={columns}
                    dataSource={data}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                    loading={loading}
                    rowKey={row => row.displayId ? 'display' + row.displayId : 'circle' + row.circleId}
                />
                <Modal
                    destroyOnClose={true}
                    title={addModalTitle}
                    visible={addModalVisible}
                    onOk={this.handleAddModalOk}
                    onCancel={this.handleAddModalCancel}
                    width={modalWidth}
                    footer={[
                        <Button key="submit" type="primary" loading={loading} onClick={this.handleAddModalOk}>
                            确认
                        </Button>,
                        <Button key="back" onClick={this.handleAddModalCancel}>
                            取消
                        </Button>,
                    ]}
                >
                    {
                        modalType == 'addCircle' &&
                        <div className="addModalPane">
                            <div className="inputItem">
                                <label>公众圈ID</label>
                                <div className="rightBlock">
                                    <Input placeholder="请输入公众圈ID" onChange={this.circleIdChange}></Input>
                                    {errorCircleIdShow && <div className="noValueError">请输入公众圈ID</div>}
                                </div>
                            </div>

                            <div className="inputItem">
                                <label>应用名称</label>
                                <div className="rightBlock">
                                    <Input placeholder="请输入应用名称" onChange={this.appNameChange.bind(this, 'add')}></Input>
                                    <span className="note">注：该名称为在公众圈应用页显示的名称</span>
                                    {errorAddAppNameShow && <div className="noValueError">请输入应用名称</div>}
                                </div>
                            </div>

                        </div>
                    }
                    {
                        modalType == 'editCircle' &&
                        <div className="addModalPane">
                            <div className="inputItem">
                                <label>公众圈ID</label>
                                <p>{editModalCircleId}</p>
                            </div>
                            <div className="inputItem">
                                <label>公众圈名称</label>
                                <p>{editModalCircleName}</p>
                            </div>
                            <div className="inputItem">
                                <label>应用名称</label>
                                <div className="rightBlock">
                                    <Input placeholder="请输入应用名称" value={editModalAppName} onChange={this.appNameChange.bind(this, 'edit')}></Input>
                                    {errorEditAppNameShow && <div className="noValueError">请输入应用名称</div>}
                                </div>
                            </div>
                        </div>
                    }
                    {
                        (modalType == 'addOpenInfo' || modalType == 'editOpenInfo') &&
                        <div className="addModalPane">
                            <div className="inputItem">
                                <label>名称</label>
                                <div className="rightBlock">
                                    <Input placeholder="请输入公开信息名称（限16字）" value={addOpenInfoName} maxLength={16} onChange={this.openInfoChange.bind(this, 'name')}></Input>
                                    {errorAddInfoNameShow && <div className="noValueError">请输入公开信息名称</div>}
                                </div>
                            </div>
                            <div className="inputItem">
                                <label>logo</label>
                                <div className="rightBlock">
                                    <div id="chooseLogo" className="chooseLogo"
                                    ></div>
                                    {errorAddInfoLogoShow && <div className="noValueError">请选择公开信息logo</div>}
                                </div>
                            </div>
                            <div className="inputItem">
                                <label>展示位置</label>
                                <div className="rightBlock">
                                    <InputNumber min={0} placeholder="请输入公开信息位置（数字越低位置越靠前）" value={addOpenInfoIndex} onChange={this.openInfoChange.bind(this, 'index')}></InputNumber>
                                    {errorAddInfoIndexShow && <div className="noValueError">请输入公开信息位置</div>}
                                </div>
                            </div>
                            <div className="inputItem">
                                <label>内容</label>
                                <div className="rightBlock">
                                    <div className="editToolPane">
                                        <UEditor id={'myeditor'} content={addOpenInfoContent} onChange={this.handleUEditorChange} />
                                    </div>
                                    {errorAddInfoContentShow && <div className="noValueError">请输入公开信息内容</div>}
                                </div>
                            </div>
                        </div>
                    }
                </Modal>
            </div>
        )
    }
}
export default OpenInfo;
